import React from 'react';
import { Link } from 'react-router-dom';

class BreadCrumComponent extends React.Component {
  renderBreadcrumbs() {
    const { breadcrumbs } = this.props;

    return breadcrumbs.map((crumb, index) => {
      const isLast = index === breadcrumbs.length - 1;

      if (isLast) {
        return (
          <span key={index} className="current">
            {crumb.label}
          </span>
        );
      } else {
        return (
          <Link
            key={index}
            to={crumb.path}
            className="prev-link"
            aria-label={`Enlace a ${crumb.label}`}
          >
            {crumb.label}
          </Link>
        );
      }
    });
  }

  render() {
    const { backUrl } = this.props;
    const hasBreadcrumbs = this.props.breadcrumbs && this.props.breadcrumbs.length > 0;

    return (
      <nav className="breadcrumb-page">
        {hasBreadcrumbs && backUrl && (
          <Link to={backUrl} className="btn-small btn-primary-tonal-outline btn-icon" aria-label="Volver">
            <span className="material-symbols-outlined">arrow_back</span>
          </Link>
        )}
        {hasBreadcrumbs ? this.renderBreadcrumbs() : <span className="current">Inicio</span>}
      </nav>
    );
  }
}

export default BreadCrumComponent;